import React from 'react'
import { prefixLink } from 'gatsby-helpers'
import { css } from 'styled-components';
import SquareContainer from './styled/SquareContainer'
import SingleNavSquare from './styled/SingleNavSquare'
import persons from '../persons.js'

const Component = React.createClass({
  render: function() {
    const coverWidth = this.props.width
    const width = coverWidth < 585 ? '1rem' : '1.5rem'
    const height = width

    return (
      <SquareContainer>
        {
          persons.map(person => <SingleNavSquare color={person.color} activeColor={this.props.activeColor} key={person.path} to={prefixLink(person.path)}></SingleNavSquare>)
        }
      </SquareContainer>
    )
  }
})

export default Component



// WEBPACK FOOTER //
// ../components/SquareMenu.js